/**
 * External Dependencies
 */
import 'jquery';
import 'intersection-observer'

$(document).ready(() => {
  // JS: Play videos while they are visible in the viewport
  const videoObserver = new IntersectionObserver((entries, observer) => {
    for (const entry of entries) {
      entry.isIntersecting ? entry.target.play() : entry.target.pause();
    }
  });
  for (const element of document.querySelectorAll('.js-viewport-aware-video')) {
    videoObserver.observe(element);
  }
});
